import { apiRequest } from "./common";

const  createProjectResearch = async (data) => {
    const response = await apiRequest('post', '/project', data);
    return response.data;
};

const updateProjectResearch = async (id, data) => {
    const response = await apiRequest('put', `/project/${id}`, data);
    return response.data;
};

const deleteProjectResearch = async (id) => {
    const response = await apiRequest('delete', `/project/${id}`);
    return response.data;
};

const getProjectResearch = async (studentId, currentGrade) => {
    const response = await apiRequest('get', `/project/by-student/${studentId}${currentGrade ? `?studentGrade=${currentGrade}`: ''}`);
    return response.data;
};

export {
    createProjectResearch,
    updateProjectResearch,
    deleteProjectResearch,
    getProjectResearch
}